import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";
import Select from "@/common/elements/InputElements/Select";
import CommonDatePicker from "@/common/elements/DatePicker";

const ReleaseInformation = ({ arrestReport = {}, form, disabled }) => {
  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>Release Information</span>
        </IntakeSectionHeader>
        <FormContainer>
          <Row gutter={16}>
            <Col span={8}>
              <FormItem
                name={["detentionsArrestReports", 0, "releaseDateTime"]}
                label="Release Date & Time"
                layout="vertical"
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                  disabled={disabled}
                />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                name={["detentionsArrestReports", 0, "releaseReasonId"]}
                label="Release Reason"
                layout="vertical"
              >
                <Select
                  options={getOptionsFromRefList(
                    "ChargeClearance",
                    false,
                    false,
                    true
                  )}
                  onChange={(e) => {
                    setTimeout(() => document.activeElement.blur(), 0);
                  }}
                  placeholder="Release Reason"
                  showSearch={false}
                  variant="outlined"
                  disabled={disabled}
                />
              </FormItem>
            </Col>
          </Row>
        </FormContainer>
      </section>
    </>
  );
};

export default ReleaseInformation;
